import React, { Fragment } from 'react';
import Head from 'next/head';
import { withRouter } from 'next/router';
import httpStatus from 'http-status';
import { get } from 'lodash';

import { NotFound } from '@zapier/common-components';

const DefaultErrorPage = ({ statusCode, err }) => {
  const titlePrefix = (statusCode && `${statusCode}: `) || '';
  const titlePostfix =
    get(err, 'message') ||
    httpStatus[statusCode] ||
    'An unexpected error has occurred';
  const title = `${titlePrefix} ${titlePostfix}`;

  return (
    <Fragment>
      <Head>
        <title>{title}</title>
      </Head>
      <NotFound errorMessage={title} />
    </Fragment>
  );
};

const errorPage = CustomErrorComponent => {
  class ErrorPage extends React.Component {
    static async getInitialProps(appContext) {
      const { req, res, err } = appContext;
      const statusCode = get(res, 'statusCode');

      // The `err` object passed to this function is the only place that Next.js
      // exposes internal server errors (which would lead to 500 responses). 4xx
      // errors will also trigger this function, at which point `err` will be
      // null.
      console.error(
        JSON.stringify({
          message: 'Next.js rendering error',
          error: get(err, 'message'),
          originalUrl: get(req, 'originalUrl'),
          stack: get(err, 'stack'),
          statusCode,
          url: get(req, 'url'),
        })
      );

      if (CustomErrorComponent && CustomErrorComponent.getInitialProps) {
        return await CustomErrorComponent.getInitialProps(appContext);
      }

      return { statusCode, err };
    }

    render() {
      if (CustomErrorComponent) {
        return <CustomErrorComponent {...this.props} />;
      }

      return <DefaultErrorPage {...this.props} />;
    }
  }

  return withRouter(ErrorPage);
};

export default errorPage;
